import React from 'react';
import Player from 'react-lottie-player';
import loadingAnimation from '@/assets/animations/loading-dots.json';

interface AnimatedLoaderProps {
  size?: number;
  speed?: number;
  className?: string;
}

/**
 * Animated loader component using Lottie animations for a more engaging loading experience
 */
export const AnimatedLoader = ({ size = 120, speed = 1, className = '' }: AnimatedLoaderProps) => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <Player
        play
        loop
        animationData={loadingAnimation}
        style={{ height: size, width: size }}
        speed={speed}
      />
    </div>
  );
};
